import { env } from './env';

export const auth0Config = {
  // jst_admin's client ID, used only for /v2/logout.
  clientId: env.AUTH0_CLIENT_ID,
  domain: env.AUTH0_DOMAIN,
};
